import { render, staticRenderFns } from "./ImageUrlOrFileUpload.vue?vue&type=template&id=d0065d6a"
import script from "./ImageUrlOrFileUpload.vue?vue&type=script&lang=ts"
export * from "./ImageUrlOrFileUpload.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports